import React, { Component } from 'react';

class SuggestionList extends Component {
    render() {
        const {showOptions, predictions,onClickAction,idList,className, listClassName, keyValue} = this.props
            if(!showOptions ||  predictions.length === 0){
                return <></>
            }else{
                return (
                <div className={`${className}`} id={idList}>
                    <ul className="custom-options2">
                        {predictions && predictions.length > 0 && predictions.map((prediction) => {
                            return (
                                <li className={listClassName}
                                    onMouseDown={() => {
                                        onClickAction(prediction[keyValue])
                                    }}>
                                        <div style={{ display: 'flex' }}>
                                            {prediction.value1 && (
                                                <span>{prediction.value1}</span>
                                            )}
                                            {prediction.value2 && (
                                                <span>{prediction.value2} {'\t\t'}</span>
                                            )}
                                            {prediction.value3 && (
                                                <span>{prediction.value3} {'\t\t'}</span>
                                            )}
                                            {prediction.value4 && (
                                                <span>{prediction.value4} {'\t\t'}</span>
                                            )}
                                            {prediction.value5 && (
                                                <span style={{color: Number(prediction.value5) === 0 ? '#B11' : '#1A1'}}>{prediction.value5}</span>
                                            )}
                                            {prediction.value6 && (
                                                <span style={{color: Number(prediction.value6) === 0 ? '#B11' : '#1A1'}}>{prediction.value6}</span>
                                            )}
                                        </div>
                                </li>
                            )
                        }
                        )}
                    </ul>
                </div>)
            }
    }
}

export default SuggestionList;